import { SRC_LIGHTBOX_OPEN, SRC_LIGHTBOX_CLOSE } from '../actions/src_lightbox'

export function srcLightbox(state = { isSrcLightboxOpen: false }, action) {
  switch (action.type) {
    case SRC_LIGHTBOX_OPEN:
      return { ...state, isSrcLightboxOpen: true, src: action.src }
    case SRC_LIGHTBOX_CLOSE:
      return { ...state, isSrcLightboxOpen: false }
    default:
      return state
  }
}
